import { render, staticRenderFns } from "./m-folder-legend.vue?vue&type=template&id=88a9acf6&scoped=true&"
import script from "./m-folder-legend.vue?vue&type=script&setup=true&lang=ts&"
export * from "./m-folder-legend.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./m-folder-legend.vue?vue&type=style&index=0&id=88a9acf6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a9acf6",
  null
  
)

export default component.exports